import { Fitter } from '../commons';

export interface FetchFitterApi {
  id: string;
}

export interface FetchFitterApiResponse {
  data: {
    fitter: Fitter;
  };
}

export interface GetFittersSuggestionsApi {
  query: string;
}

export interface GetFittersSuggestionsApiResponse {
  fitters: { id: string; name: string }[];
}
